<script setup lang="ts">
    import { requireCanEditCode as vRequireCanEditCode } from '@/shared/directives/requirePermission';
    import { useRouter } from 'vue-router';
    import {
        getTRDocumentDetailsLink,
        getTRRevisionQueryTemplateListLink,
        getTRRevisionContentEditorLink
    } from '@/shared/helpers/routing';
    import { TRDocumentRecord } from './TRDocumentQueries';
    import { useTRDocumentStore } from './TRDocumentStore';

    const store = useTRDocumentStore();
    const router = useRouter();

    async function onQueryTemplatesClick(document: TRDocumentRecord): Promise<void> {
        await router.push(getTRRevisionQueryTemplateListLink(document.identity));
    }

    async function onEditDocumentClick(document: TRDocumentRecord): Promise<void> {
        await router.push(getTRRevisionContentEditorLink({
            trDocumentIdentity: document.identity
        }));
    }

    function onNewTRDocument(): void {
        alert('NOT YET IMPLEMENTED');
    }
</script>

<template>
    <div class="is-clearfix">
        <b-button
            v-require-can-edit-code="{ libraryName: 'TRDocument' }"
            type="is-primary"
            class="is-pulled-right"
            icon-left="plus-circle-outline"
            @click="onNewTRDocument()">
            Create new TR document
        </b-button>
    </div>
    <div>
        <b-table
            :data="store.trDocumentList"
            :loading="store.initializing"
            striped>
            <b-table-column
                v-slot="tableProps"
                field="name"
                label="Document name"
                sortable>
                <router-link :to="getTRDocumentDetailsLink(tableProps.row.identity)">
                    {{ tableProps.row.name }}
                </router-link>
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="description"
                label="Description"
                sortable>
                {{ tableProps.row.description }}
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="technologyDescription"
                label="Technology area"
                sortable>
                {{ tableProps.row.technologyDescription }}
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="validityContextDescription"
                label="Validity context"
                sortable>
                {{ tableProps.row.validityContextDescription }}
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="identity"
                label="&nbsp;"
                centered>
                <b-button
                    type="is-primary"
                    icon-left="table"
                    outlined
                    @click="onQueryTemplatesClick(tableProps.row)">
                    Query templates
                </b-button>
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="identity"
                label="&nbsp;"
                centered>
                <b-button
                    type="is-primary"
                    icon-left="pencil"
                    outlined
                    @click="onEditDocumentClick(tableProps.row)">
                    Edit content
                </b-button>
            </b-table-column>
        </b-table>
    </div>
</template>
